import { metadata } from './metadataApi';

export const enhancedIRODSApi = metadata.enhanceEndpoints({
    addTagTypes: ['SearchForDatasetsByDatasetIdMetaSearchDatasetIdGet'],
    endpoints: {
        searchForDatasetsByDatasetIdMetaSearchDatasetIdGet: {
            providesTags: ['SearchForDatasetsByDatasetIdMetaSearchDatasetIdGet'],
        },
        updateDatasetMetadataMetaDatasetPut: {
            invalidatesTags: ['SearchForDatasetsByDatasetIdMetaSearchDatasetIdGet'],
        },
    },
});

export const {
    useUpdateDatasetMetadataMetaDatasetPutMutation,
    useCreateNewEmptyDatasetMetaDatasetPostMutation,
    useSearchThroughTheDatasetsMetaSearchPostMutation,
    useSearchForDatasetsByDatasetIdMetaSearchDatasetIdGetQuery,
    useGetDatasetsStatisticsMetaStatisticsGetQuery,
    useListAvailableDatasetTypesMetaInfoDatasettypesGetQuery,
    useGetStatisticsForResourceMetaStatisticsResourcePostMutation,
    useGetStatisticsForAllResourcesInSpecifiedProjectMetaStatisticsProjectresourcesPostMutation,
    useGetMetricsFromDdiActionsBasedOnProjectAndTimeIntervalMetaMetricsGetQuery,
    useGetAvailableMetricTypesBasedOnUserPermissionsMetaMetricsMetrictypesGetQuery,
    useVersionOfTheApiMetaInfoGetQuery,
    useHealthOfTheApiMetaHealthApiGetQuery,
    useHealthOfOpenSearchMetaHealthOpensearchGetQuery,
    useGetSizeOfADatasetByItsIdMetaSizeGetQuery,
    useGetInformationAboutALocationMetaLocationPostMutation,
    useLazySearchForDatasetsByDatasetIdMetaSearchDatasetIdGetQuery,
} = enhancedIRODSApi;
